import React, { useState, useEffect, useCallback, useRef } from 'react'

// Deps
import debounce from 'lodash/debounce'

// Partials
import Btn from 'views/shared/partials/btn'

const Dropdown = (props) => {
	const _mounted = useRef(false);
	const container = useRef();

	const [focused, setFocused] = useState(false);
	const [childFocused, setChildFocused] = useState(false);
	const [children, setChildren] = useState([]);

	const [open, setOpen] = useState(false);

	const focusChange = useCallback(debounce((newState) => {
		if(_mounted) {
			setOpen(newState);
		}
	}, 50, {leading: false}), []);

	const focus = (state) => {
		setTimeout(function() {
			if(_mounted.current) {
				setChildFocused(state);
			}
		}, 20);

	}

	useEffect(() => {
		_mounted.current = true;
		return(() => {
			_mounted.current = false;
		})
	}, []);

	useEffect(() => {
		focusChange(focused || childFocused);
	}, [focused, childFocused, focusChange]);

	useEffect(() => {
		let newChildren = props.children.map((child, nth) => {
			return React.cloneElement(
				child,
				{
					key: nth,
					onFocus: () => {  focus(true); },
					onBlur: () => {  focus(false); },
					onClick: (e) => {  if(child.props.onClick) { child.props.onClick(e); } focus(false); },
				}
			)
		});

		if(_mounted.current) {
			setChildren(newChildren);
		}
	}, [props.children]);

	return (
		<div
			ref={container}
			onBlur={() => { if(_mounted.current) { setFocused(false) } }}
			className={'dropdown' + (open ? ' open' : '')}>
			<Btn
				small white low
				icon={props.icon}
				onClick={() => { if(_mounted.current) { setFocused(true); } }}
				className="dropdown-btn small-icon-pre">
				{props.text}
			</Btn>

			<div className="dropdown-content">
				<div className="dropdown-innerwrap">
					{children.map((child) => {
						return child
					})}
				</div>
			</div>
		</div>
	)
};

Dropdown.defaultProps = {
}

export default Dropdown